<template>
  <div>
    <li class="as_li" @click="changeScope">
      <div class="fl">
        <i class="iconfont">&#xe620;</i>
        <span>发布范围</span>
      </div>
      <div class="fr">
        <span>{{ scope }}</span>
        <div class="jt"></div>
      </div>
    </li>
    <div class="choosed clearfix" v-show="reset_choose">
      <div class="c_fr">已选人:</div>
      <div class="choosed_friend">
        <el-tag
          v-for="(item,index) in friendArr"
          style="margin: 0 10px 10px 0;"
          :key="index"
          closable
          @close="handleClose(item,index,'f')"
        >{{item.name}}</el-tag>
      </div>
      <div class="c_fr">已选群:</div>
      <div class="choosed_friend">
        <el-tag
          v-for="(item,index) in groupArr"
          style="margin: 0 10px 10px 0;"
          :key="index"
          closable
          @close="handleClose(item,index,'g')"
        >{{item.name}}</el-tag>
      </div>
      <div class="c_fr">已选组织:</div>
      <div class="choosed_friend">
        <el-tag
          v-for="(item,index) in orgArr"
          style="margin: 0 10px 10px 0;"
          :key="index"
          closable
          @close="handleClose(item,index,'o')"
        >{{item.name}}</el-tag>
      </div>
      <div class="c_fr">已选行业:</div>
      <div class="choosed_friend">
        <el-tag
          v-for="(item,index) in hyArr"
          style="margin: 0 10px 10px 0;"
          :key="index"
          closable
          @close="handleClose(item,index,'h')"
        >{{item.name}}</el-tag>
      </div>
      <div class="c_fr">已选地区:</div>
      <div class="choosed_friend">
        <el-tag
          v-for="(item,index) in dqArr"
          style="margin: 0 10px 10px 0;"
          :key="index"
          closable
          @close="handleClose(item,index,'d')"
        >{{item.name}}</el-tag>
      </div>
      <div class="choose_re fr" @click="choose">继续选择</div>
    </div>
    <div class="mask" v-show="muta_status" @click="mask_status">
      <div style="width:100%">
        <div class="boxtitle" v-show="scope_status">请选择发布范围</div>
        <div class="selrangebox" id="selrangebox">
          <el-radio-group v-model="radio1" size="medium" @change="changeRa" v-show="scope_status">
            <el-radio
              v-for="(item, index) in scope_arr"
              :key="index"
              :label="index"
              border
            >{{ item }}</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "umMrange",
  data() {
    return {
      reset_choose: false,
      scope: "仅个人可见（草稿）",
      scope_arr: ["仅个人可见（草稿）", "所有人可见", "范围可见"],
      muta_status: false,
      scope_status: false
    };
  },
  props: ["orgArr", "friendArr", "groupArr", "hyArr", "dqArr", "radio1"],
  watch: {
    radio1(val) {
      if (val == "0") {
        this.scope = "仅个人可见（草稿）";
      } else if (val == "1") {
        this.scope = "所有人可见";
      } else if (val == "2") {
        this.scope = "范围可见";
        this.reset_choose = true;
      }
    }
  },
  mounted() {
    if (this.radio1 == "0") {
      this.scope = "仅个人可见（草稿）";
    } else if (this.radio1 == "1") {
      this.scope = "所有人可见";
    } else if (this.radio1 == "2") {
      this.scope = "范围可见";
      this.reset_choose = true;
    }
  },
  methods: {
    choose() {
      this.$emit("chooseDialog", 2);
    },
    changeRa(val) {
      // 选择发布范围
      this.radio1 = val;
      this.reset_choose = false;
      this.scope = this.scope_arr[val];
      if (val == 2) {
        // ==2的时候弹出选人
        this.reset_choose = true;
      }
      this.$emit("chooseDialog", val);
    },
    /**tag表签删除 */
    handleClose(item, index, type) {
      if (type == "f") {
        this.friendArr.splice(index, 1);
      } else if (type == "g") {
        this.groupArr.splice(index, 1);
      } else if (type == "o") {
        this.orgArr.splice(index, 1);
      } else if (type == "h") {
        this.hyArr.splice(index, 1);
      } else if (type == "d") {
        this.dqArr.splice(index, 1);
      }
    },
    changeScope() {
      this.muta_status = true;
      this.scope_status = true;
      this.radio1 = parseInt(this.radio1);
      $("#selrangebox").css("height", "180px");
    },
    mask_status() {
      this.muta_status = false;
      this.scope_status = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.choosed {
  float: left;
  width: 100%;
  padding: 10px 15px;
  .c_fr {
    font-size: 15px;
  }
  .choosed_friend {
    margin-top: 10px;
    li {
      display: inline-block;
      border: 1px solid #d9ecff;
      background: #ecf5ff;
      border-radius: 3px;
      padding: 0 10px;
      height: 30px;
      color: #409eff;
      line-height: 30px;
      font-size: 14px;
      margin-bottom: 8px;
      margin-left: 3px;
    }
  }
  .choose_re {
    background: #2e9cf1;
    border-color: #2e9cf1;
    color: #fff;
    padding: 10px;
    text-align: center;
    height: 40px;
    line-height: 20px;
    border-radius: 5px;
    width: 100px;
  }
}
.mask {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  .boxtitle {
    text-align: center;
    line-height: 40px;
    width: 73.3%;
    background: #fff;
    font-size: 16px;
    margin: 0 auto;
    border-radius: 3px 3px 0 0;
  }
  .selrangebox {
    // position: absolute;
    height: 220px;
    width: 73.3%;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    margin: auto;
    background: #fff;
    border-radius: 0 0 3px 3px;
    padding: 0 15px 20px;
    font-size: 15px;
    overflow-y: auto;
  }
}
.check_box {
  // width: 100%;
  display: flex;
  // margin-top: 60px;
  // border-bottom: 1px solid #EDEDED;
  div {
    flex: 1;
    font-size: 15px;
    text-align: center;
    // padding: 10px 0;
    .check_in {
      opacity: 0;
    }
    .inner {
      width: 14px;
      height: 14px;
      display: inline-block;
      border-radius: 50%;
      position: relative;
      border: 1px solid #ccc;
      .inner_in {
        width: 8px;
        height: 8px;
        display: inline-block;
        background: #2e9cf1;
        padding: 3px;
        border-radius: 50%;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
    }
    .inner_active {
      border: 1px solid #2e9cf1 !important;
    }
  }
  .active {
    color: #2e9cf1;
  }
}
.as_li {
  width: 100%;
  float: left;
  font-size: 15px;
  padding: 15px;
  border-bottom: 1px solid #ededed;
}
</style>


// WEBPACK FOOTER //
// src/packages/mrange/um-mrange.vue